var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ClientService from '../../../api/ClientService';
import { Loading } from 'element-ui';
import _ from 'lodash';
import Pager from '../../../common/Pager';
import GoodService from "../../../api/GoodService";
var LIMIT = 25;
var SupplierGoodsList = (function (_super) {
    __extends(SupplierGoodsList, _super);
    function SupplierGoodsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.page = new Pager().setLimit(LIMIT);
        _this.categoryData = [];
        _this.listData = [];
        _this.tableHeight = 300;
        _this.currentCount = 0;
        _this.formData = {
            text: '',
            goods_bind_status: -1,
        };
        _this.goodsBindStatusList = [
            {
                id: -1,
                label: '全部'
            },
            {
                id: 1,
                label: '已绑定'
            },
            {
                id: 0,
                label: '未绑定'
            }
        ];
        return _this;
    }
    SupplierGoodsList.prototype.watch_againGetSupplierGoods = function () {
        this.getSupplierGoods();
    };
    SupplierGoodsList.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.goodService = GoodService.getInstance();
        this.getType();
        this.getSupplierGoods();
    };
    SupplierGoodsList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
        this.$refs.grid.$refs.bodyWrapper.addEventListener('scroll', _.throttle(this.gridScroll.bind(this), 100));
    };
    SupplierGoodsList.prototype.gridScroll = function (e) {
        var scrollHeight = e.target.scrollHeight;
        if (scrollHeight - e.target.clientHeight - e.target.scrollTop < scrollHeight * 0.01) {
            if (this.currentCount >= LIMIT) {
                this.page.setNext();
                this.getSupplierGoods();
            }
        }
    };
    SupplierGoodsList.prototype.getType = function () {
        var _this = this;
        this.goodService.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    SupplierGoodsList.prototype.getSupplierGoods = function () {
        var _this = this;
        var params = {
            goods_type_id: this.formData.category,
            keyword: this.formData.text,
            bind_type: 2,
            agent_warehouse_id: this.clientIds,
            supplier_to_business_id: this.supplier_to_business_id,
            goods_bind_status: this.formData.goods_bind_status
        };
        Object.assign(params, this.page);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.goodService.getGoodListAllFormat(params).then(function (res) {
            if (res.data.success) {
                var currentPageNum = _this.page.getPage().page;
                var data = res.data.data;
                _this.listData = currentPageNum > 1 ? _this.listData.concat(data) : data;
                _this.currentCount = data.length;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    SupplierGoodsList.prototype.search = function () {
        this.$refs.grid.$refs.bodyWrapper.scrollTop = 0;
        this.page.clear().setLimit(LIMIT);
        this.getSupplierGoods();
    };
    SupplierGoodsList.prototype.bindGood = function (good) {
        this.$emit('bindGood', good);
    };
    SupplierGoodsList.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], SupplierGoodsList.prototype, "clientIds", void 0);
    __decorate([
        Prop({
            default: []
        })
    ], SupplierGoodsList.prototype, "supplierGoodsIds", void 0);
    __decorate([
        Prop({
            default: false,
            type: Boolean
        })
    ], SupplierGoodsList.prototype, "againGetSupplierGoods", void 0);
    __decorate([
        Watch("againGetSupplierGoods")
    ], SupplierGoodsList.prototype, "watch_againGetSupplierGoods", null);
    SupplierGoodsList = __decorate([
        Component
    ], SupplierGoodsList);
    return SupplierGoodsList;
}(Vue));
export default SupplierGoodsList;
